<template>
  <div class="sm:col-12 md:col-12 lg:col-12">
    <div class="surface-card shadow-2 p-3 border-round-lg mt-2 ml-2 mr-2">
        <div class="flex justify-content-between flex-wrap">
            <div class="flex align-items-center justify-content-center text-xl ml-2">
                Location wise Details
            </div>
            <div class="flex align-items-center justify-content-center text-xl mr-2 mb-2">

                <Button label="Export" icon="pi pi-file-export" raised  size="small" class="ml-2" @click="exportLocationDataCSV" v-tooltip.top="'Excel format'"/>
            </div>
        </div>

        <div class="field col">
            <DataTable ref="locationWiseData" :value="filteredData" 
            stripedRows size="small" 
            showGridlines 
            :loading="tableLoading" v-model:filters="filters" 
            exportFilename="location_wise_details"
            filterDisplay="menu" 
            tableStyle="min-width: 50rem; max-width:100%" 
            dataKey="id" 
            paginator :rows="100" :rowsPerPageOptions="[100, 200, 1000]" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" 
            scrollable scrollHeight="60vh" 
            :globalFilterFields="['orderNo', 'item', 'category', 'deliveryLocation', 'deliveredStatus', 'installationStatus', 'installationReqd', 'packing']" >

                <template #empty>
                    <div class="flex align-items-center justify-content-center my-2">
                        <label class="text-xl font-medium">
                            No data
                        </label>
                    </div>
                </template>    
                <Column header="Sl No.">
                    <template #body="slotProps">{{1 + slotProps.index}}</template>
                </Column>
                <Column field="deliveryLocation" header="Location" width="20%">
                    <template #body="slotProps">
                        {{slotProps.data.deliveryLocation}}
                    </template>
                    <template #filter="{ filterModel }">
                        <MultiSelect v-model="filterModel.value" :options="locations" filter placeholder="Select One" class="p-column-filter">
                            <template #option="slotProps">
                                {{slotProps.option}}
                            </template>
                        </MultiSelect>
                    </template>
                </Column>
                <Column field="item" header="Item">
                    <template #body="slotProps">
                        {{slotProps.data.item}}
                    </template>
                    <template #filter="{ filterModel }">
                        <InputText v-model="filterModel.value" type="text" class="p-column-filter" placeholder="Search by name" />
                    </template>
                </Column>
                <Column field="packing" header="Packing">
                    <template #body="slotProps">
                        {{slotProps.data.packing}}
                    </template>
                    <template #filter="{ filterModel }">
                        <InputText v-model="filterModel.value" type="text" class="p-column-filter" placeholder="Search by packing" />
                    </template>
                </Column>
                <Column field="category" header="Category">
                    <template #body="slotProps">
                        {{slotProps.data.category}}
                    </template>
                    <template #filter="{ filterModel }">
                        <Dropdown v-model="filterModel.value" :options="categories" placeholder="Select Category" class="p-column-filter" style="min-width: 12rem" :showClear="true">
                            <template #option="slotProps">
                                {{slotProps.option}}
                            </template>
                        </Dropdown>
                    </template>
                </Column>
                <Column field="orderNo" header="Order No.">
                    <template #body="slotProps">
                        {{slotProps.data.orderNo}}
                    </template>
                    <template #filter="{ filterModel }">
                        <InputText v-model="filterModel.value" type="text" class="p-column-filter" placeholder="Search by Order No." />
                    </template>
                </Column> 
                
                <Column field="orderDate" header="Order date">
                    <template #body="slotProps">
                        {{slotProps.data.orderDate}}
                    </template>
                </Column> 
                <Column field="quantity" header="Quantity">
                    <template #body="slotProps">
                        {{formatNumber(slotProps.data.quantity)}}
                    </template>
                </Column>
                <Column field="deliveredStatus" header="Delivery Status">
                    <template #body="slotProps">
                        <Tag :value="slotProps.data.deliveredStatus" :severity="deliveryStatusSeverity(slotProps.data.deliveredStatus)" ></Tag>
                    </template>
                    <template #filter="{ filterModel }">
                        <Dropdown v-model="filterModel.value" :options="deliveryStatusOptions" placeholder="Select Status" class="p-column-filter" style="min-width: 12rem" :showClear="true">
                            <template #option="slotProps">
                                <Tag :value="slotProps.option" :severity="deliveryStatusSeverity(slotProps.option)" />
                            </template>
                        </Dropdown>
                    </template>
                </Column>
                <Column field="deliveredQty" header="Delivered">
                    <template #body="slotProps">
                        {{formatNumber(slotProps.data.deliveredQty)}}
                    </template>
                </Column>  
                <Column field="pendingQty" header="Pending Delivery">
                    <template #body="slotProps">
                        {{formatNumber(slotProps.data.pendingQty)}}
                    </template>
                </Column>
                <Column field="installationStatus" header="Installation Status">
                    <template #body="slotProps">
                        <Tag :value="slotProps.data.installationStatus" :severity="installationStatusSeverity(slotProps.data.installationStatus)" ></Tag>
                    </template>
                    <template #filter="{ filterModel }">
                        <Dropdown v-model="filterModel.value" :options="installationStatusOptions" placeholder="Select Status" class="p-column-filter" style="min-width: 12rem" :showClear="true">
                            <template #option="slotProps">
                                <Tag :value="slotProps.option" :severity="installationStatusSeverity(slotProps.option)" />
                            </template>
                        </Dropdown>
                    </template>
                </Column>                
                <Column field="installationReqd" header="Installation Reqd">
                    <template #body="slotProps">
                        <Tag :value="slotProps.data.installationReqd" :severity="installationReqdSeverity(slotProps.data.installationReqd)" style="width: 6rem; text-align: center; font-size: 0.8rem;"></Tag>
                    </template>
                    <template #filter="{ filterModel }">
                        <Dropdown v-model="filterModel.value" :options="installationReqdOptions" placeholder="Select Status" class="p-column-filter" style="min-width: 12rem" :showClear="true">
                            <template #option="slotProps">
                                <Tag :value="slotProps.option" :severity="installationReqdSeverity(slotProps.option)" />
                            </template>
                        </Dropdown>
                    </template>
                </Column>
                <Column field="installedQty" header="Installed">
                    <template #body="slotProps">
                        {{formatNumber(slotProps.data.installedQty)}}
                    </template>
                </Column> 
                <Column field="pendingInstallation" header="Pending Installation">
                    <template #body="slotProps">
                        {{formatNumber(slotProps.data.pendingInstallation)}}
                    </template>
                </Column>                                     
            </DataTable>
        </div>
    </div>
  </div>
</template>

<script>
import Button from 'primevue/button';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import {  getCategories, getDeliveryLocations, locationWiseReport } from '@/services/apiService';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import Tag from 'primevue/tag';
import { FilterMatchMode, FilterOperator } from 'primevue/api';
import MultiSelect from 'primevue/multiselect';

export default {
    
    components: {
        Button,
        DataTable,
        Column,
        Dropdown,
        InputText,
        Tag,
        MultiSelect,
    },
    data() {
        return {
            tableLoading: false,
            filteredData: [],
            deliveryStatusOptions:['Pending', 'Delivered'],
            installationStatusOptions:['Installation Complete', 'Installation Pending'],
            installationReqdOptions:['Yes', 'No'],
            filters: null,
            locations:[],
            categories:[],
        };
    },
    methods:{
        fetchLocationWiseData(){
            this.tableLoading = true;
            locationWiseReport().then((response) => {
                this.filteredData = response.data.data;                                
                this.tableLoading = false;
            }).catch((error) => {
                this.showErrorToast(error.response.data);
                this.tableLoading = false;
            });
        },
        deliveryStatusSeverity(status){
            switch (status) {
                case 'Pending': 
                    return 'danger';
                case 'Delivered':
                    return 'success';              
                default:
                    break;
            }
        },
        installationStatusSeverity(status){
            switch (status) {
                case 'Installation Complete': 
                    return 'success';
                case 'Installation Pending':
                    return 'warning';            
                default:
                    break;
            }
        },
        installationReqdSeverity(status){
            switch (status) {
                case 'Yes': 
                    return 'success';
                case 'No':
                    return 'warning';            
                default:
                    break;
            }
        },
        showErrorToast(error){
            this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 4000 });
        },
        exportLocationDataCSV() {
            this.$refs.locationWiseData.exportCSV();
        },
        formatNumber(value) {
            return value.toLocaleString('en-IN');
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                orderNo: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
                deliveredStatus: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                installationStatus: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                deliveryLocation: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.IN }] }, 
                item: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
                packing: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
                category: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                installationReqd: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
            };
        },
    },
    created(){
        this.initFilters();
    },
    mounted() {
        this.fetchLocationWiseData();
        getDeliveryLocations().then((response) => {
            response.data.map((location) => {
                this.locations.push(location.name);
            });
        }).catch((error) => {
            this.showErrorToast(error.response.data);
        });

        getCategories().then((response) => {
            response.data.map((category) => {
                this.categories.push(category.label);
            });
        }).catch((error) => {
            this.showErrorToast(error.response.data);
        });
    },
}
</script>

<style>

</style>